<template>
    <div class="license-plate noselect">
        <div class="cph-box">
            <div class="addCar-content-header flex align-center">
                <img src="@/assets/images/mycar/num-input-icon.png" alt="" />
                <p>{{ text }}</p>
            </div>
            <div class="cph-wrap cph-wrap-shadow">
                <span :class="{ active: clickIndex == index }" v-for="(item, index) in shadow" :key="index" @click="cphInputClick(index)">
                    {{ sonCarNoList[index] }}
                </span>
            </div>
        </div>
        <transition name="slide">
            <div class="keyboard-wrap" @click="clickBoard" v-show="show_keyboard">
                <!--=====   头部  =====-->
                <div class="keyboardHeader">
                    <div>
                        <span class="specials" :class="{ kspecials: activeIndex < 6 }" v-for="(item, index) in specials" :key="index"> {{ " " }}</span>
                    </div>
                    <div class="close flex">
                        <span class="kclose" @click="confirmBtnFn()">关闭</span>
                        <span class="kcdone" @click="confirmBtnFn(true)">完成</span>
                    </div>
                </div>

                <!--=====   英文数字  =====-->
                <div>
                    <div class="keyboard">
                        <span @touchstart="touchstart" @touchend="touchend" v-for="(item, index) in numbers" :key="index">{{ item }}</span>
                        <span @touchstart="touchstart" @touchend="touchend" class="k-del">清除</span>
                    </div>
                    <!-- <div class="keyboard">
                        <span @touchstart="touchstart" @touchend="touchend" v-for="(item, index) in letters.slice(0, 10)" :key="index">{{ item }}</span>
                    </div>
                    <div class="keyboard">
                        <span @touchstart="touchstart" @touchend="touchend" v-for="(item, index) in letters.slice(10, 19)" :key="index">{{ item }}</span>
                    </div> -->
                    <div class="keyboard">
                        <!-- <span @touchstart="touchstart" @touchend="touchend" class="k-done k-done2">完成</span> -->
                        <!-- <span @touchstart="touchstart" @touchend="touchend" v-for="(item, index) in letters.slice(19)" :key="index">{{ item }}</span> -->
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "CarKeyboard",
    props: {
        text: {
            type: String,
            default: "请输入泊位号",
        },

        //输入的泊位列表
        carNoList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            isDefault: false,
            numbers: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
            letters: ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "A", "S", "D", "F", "G", "H", "J", "K", "L", "Z", "X", "C", "V", "B", "N", "M"],
            specials: ["领", "警", "港", "澳", "学", "挂"],
            newCph: [],
            shadow: new Array(6),
            show_keyboard: true, //是否展示键盘
            clickIndex: 0,

            sonCarNoList: [...this.carNoList],
        };
    },

    watch: {
        carNoList: {
            handler(newValue, oldValue) {
                this.sonCarNoList = newValue;
                this.newCph = this.sonCarNoList;
            },
        },
    },
    computed: {
        activeIndex() {
            return this.clickIndex;
        },
    },
    methods: {
        //isSearch 是否直接搜索
        confirmBtnFn(isSearch = false) {
            this.$emit("confirmBtnFn", this.sonCarNoList.join(""), isSearch);
            this.show_keyboard = false;
        },
        clickBoard(e) {
            if (e.target.tagName.toLowerCase() === "span") {
                if (e.target.className.indexOf("k") === -1 && this.clickIndex < 6) {
                    this.sonCarNoList[this.clickIndex] = e.target.textContent;
                    this.$emit("update:carNoList", this.sonCarNoList);
                    this.newCph = this.sonCarNoList;
                    this.clickIndex += 1;

                    if (this.clickIndex > 5) {
                        this.clickIndex = 5;
                        this.confirmBtnFn(true);
                    }
                } else if (e.target.className === "k-del") {
                    if (this.newCph[this.clickIndex] == "") {
                        this.clickIndex -= 1;
                        // return;
                    }
                    this.newCph[this.clickIndex] = "";
                    this.sonCarNoList[this.clickIndex] = "";
                    this.$emit("update:carNoList", this.sonCarNoList);
                    //后补的逻辑 需要强制更新
                    this.$forceUpdate();
                    if (this.clickIndex < 0) this.clickIndex = 0;
                } else if (e.target.className.indexOf("k-done2") !== -1) {
                    this.confirmBtnFn();
                }
            }
        },
        cphInputClick(i) {
            this.clickIndex = i;
            this.show_keyboard = true;
        },
        touchstart(e) {
            // e.target.classList.add("active_key");
        },
        touchend(e) {
            // e.target.classList.remove("active_key");
        },
    },
};
</script>

<style lang="less" scoped>
.popTop {
    position: relative;

    .popTitle {
        font-size: 14px;
        padding: 10px;
    }

    .close {
        position: absolute;
        top: 0;
        right: 0;
    }
}

.popContent {
    box-sizing: border-box;
    padding: 20px;
    min-height: 125px;
    display: flex;
    justify-content: center;
}

.popFooter {
    display: flex;

    .btn {
        font-size: 14px;
        color: #222222;
        flex: 1;
        padding: 14px 0;
        background: #efefef;
        font-weight: bold;
    }

    .cancelBtn {
        flex: 1;
    }

    .confirmBtn {
        flex: 1;
        background: #ff2343;
        color: #fff;
    }
}

.license-plate {
    // padding: 10px;

    .cph-wrap {
        display: flex;
        justify-content: space-around;
        font-size: 18px;
        line-height: 40px;

        .active {
            height: 80px;
            width: 74px;
            border: 1px solid #4facfb;
            line-height: 74px;
        }
        span {
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #eee;
            border-radius: 8px;
            height: 80px;
            width: 74px;
            color: #222;
            z-index: 99;
            font-size: 41px;
            &:first-of-type {
                margin-left: 0;
            }
        }
    }

    .cph-wrap-shadow {
        background-color: #fff;
        z-index: 0;
        span {
            border: 1px solid #eee;
            border-radius: 8px;
            height: 80px;
            width: 74px;
            font-size: 41px;
            line-height: 74px;
        }
    }

    .keyboard-wrap {
        background: #ececec;
        // padding: 0 2px 0;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9999;
        .keyboardHeader {
            display: flex;
            background-color: #fff;
            padding: 20px 6px;
            margin-bottom: 20px;
            justify-content: space-between;
            align-items: center;

            .specials {
                font-size: 36px;
                margin-left: 20px;
                color: #333;
            }

            .kspecials {
                color: #ccc;
            }

            .close {
                padding-right: 10px;

                span {
                    color: red;
                    display: block;
                    font-size: 36px;
                    white-space: nowrap;
                }
                .kcdone {
                    margin-left: 20px;
                    color: #4facfb;
                }
            }
        }
    }

    .keyboard {
        margin-top: 10px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        position: relative;

        span {
            display: flex-block;
            justify-content: center;
            align-items: center;
            font-size: 40px;
            font-weight: 500;
            color: #333333;
            background-color: #fff;
            display: inline-block;
            padding: 18px 0;
            width: 225px;
            height: 100px;
            text-align: center;
            box-shadow: 0 2px 0 0 #999999;
            border-radius: 10px;
            margin: 6px 5px;
        }
        span:active {
            background-color: rgb(224, 224, 224);
        }
        .k-del {
            position: absolute;
            font-size: 35px;
            right: 23px;
            bottom: 0px;
            width: 225px;
            height: 100px;
            color: #333333;
            background: #e4e4e4;
            display: inline-block;
            border-radius: 10px;
            margin-bottom: 6px;
        }
        .k-del:active {
            background-color: rgb(185, 185, 185);
        }
        .k-del img {
            display: block;
            margin: 9px auto;
        }

        .k-done {
            position: absolute;
            right: 2px;
            padding: 0 16px;
            display: block;
            background-color: #0084ff;
            color: #fff;
            font-weight: bold;
        }

        .k-done2 {
            left: 2px;
            // width: 40px;
        }
    }

    .keyboard > div {
        display: flex;
    }

    .slide-enter-active,
    .slide-leave-active {
        transition: all 0.3s;
        opacity: 1;
        transform: translateY(0);
    }

    .slide-enter,
    .slide-leave-to {
        opacity: 0;
        transform: translateY(400px);
    }
}

.cph-box {
    position: relative;
    margin: 23px auto;
    background-color: #fff;
    border-radius: 5px;
    .addCar-content-header {
        margin-bottom: 23px;
        img {
            width: 32px;
            height: 27px;
        }
        p {
            font-size: 30px;
            color: #212121;
            margin-left: 10px;
        }
    }
    .numtitle {
        font-size: 18px;
        color: #222222;
        text-align: center;
        line-height: 50px;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        font-weight: normal;
    }
    .cph-default {
        margin: 24px 0;
    }
    .cph-confirm {
        .cph-confirm-btn {
            width: 702px;
            height: 70px;
            font-size: 32px;
            border-radius: 16px;
            color: #fff;
            background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
        }
    }
}

span.hide {
    opacity: 0;
}

.active_key {
    background-color: rgb(224, 224, 224);
    // opacity: 0.2;
}
</style>
